﻿import { Container } from 'statuo';

import { merge } from 'lodash';

import getTeetimes from '../../../03-api/teetime/getteetimes';

import { getSessionStorage } from '../../session-manager';
import { formatSimpleDate } from '../../utilities/date-formatter';

import saveToSessionStorageTransform from '../transforms/save-to-storage';
import addEndpointResponseTransform from '../transforms/add-endpoint-response';


/* ========================================================================== */

const filtersKey = 'filters',
	today = new Date(),
	currDate = formatSimpleDate(today, '-'),
	initialState = merge(
		{},
		{
			// some sensible defaults here
			holes: 0,
			players: 0,
			date: currDate
		},
		getSessionStorage(filtersKey) || {}
	),
	responseKey = 'response',
	saveToSessionStorageTransformConfig = {
		storageKey: filtersKey,
		omitKeys: [responseKey]
	},
	addEndpointResponseTransformConfig = {
		endpoint: getTeetimes,
		omitKeys: [responseKey],
		stateKey: responseKey
	};

/* ========================================================================== */

export default class extends Container {
	constructor() {
		super({
			state: initialState,
			transforms: [
				saveToSessionStorageTransform(saveToSessionStorageTransformConfig),
				addEndpointResponseTransform(addEndpointResponseTransformConfig)
			]
		});
	}
}
